import React from 'react';
import * as emotion from 'emotion';
export * from 'emotion';
import createEmotionStyled from 'create-emotion-styled';

var index = createEmotionStyled(emotion, React);

export default index;
